import { useRoomCapacity } from "@/components/features/items/edit/room/_shared/ui/_components/capacity/_hooks/use-capacity";

import { useProductDummyRoomFormModelContext } from "../../../../context";

export const useDummyRoomCapacity = () => {
	const { viewModel, onSetViewModel } = useProductDummyRoomFormModelContext();
	const { capacityAdultMaximum, capacityKidsMaximum, capacityPeopleMaximum, isKidsUnavailable } = viewModel;

	return useRoomCapacity({
		capacityAdultMaximum,
		capacityKidsMaximum,
		capacityPeopleMaximum,
		isKidsUnavailable,
		onSetViewModel,
	});
};
